import { AppConfig } from '../../app-config'
import { PAID_LANDING_GCM } from '../../components/gcm/Constants'
import { getLeadSource } from '../analytics/leadSourceHelper'
import { triggerSimpleAjax } from '../http-helper'
import redirector from '../redirector'

export default function getCost({
	itineraryId,
	regionCode,
	req_data,
	router,
	lastLocation,
	//campaign = false,
	changeRoute = true, // indicates routes should change or not.
	setVisible = () => null,
	setModalState = () => null,
}) {
	return new Promise((res, rej) => {
		const url = `${AppConfig.api_url}itinerary/${itineraryId}/calculateCost`
		req_data.leadSource = getLeadSource({
			router,
			lastLocation,
			itineraryId,
		})

		// if (isCredDeals()) {
		//   req_data.leadSource.prodType = 'CRED';
		// }

		// if (req_data.costingConfig && req_data.costingConfig.nationality) {
		//   let nationalityVal =
		//     typeof req_data.costingConfig.nationality === 'string'
		//       ? req_data.costingConfig.nationality
		//       : req_data.costingConfig.nationality.value;
		//   req_data.costingConfig.nationality = nationalityVal;
		// }

		triggerSimpleAjax({
			url,
			method: 'POST',
			body: req_data,
			onSuccess: () => {
				if (changeRoute) {
					const path = `/customize/${regionCode}/view/calculating-cost/${itineraryId}`
					setVisible(false)
					setModalState(PAID_LANDING_GCM)
					redirector(path)

					// if (campaign) {
					// history.push(
					//   getGetCostingHelperRoute({
					//     pathname: history.location.pathname,
					//     itineraryId: itineraryId,
					//     target: 'costing-delay'
					//   })
					// );
					// } else {
					//   history.push(
					//     itineraryModalsRouteHelper({
					//       itineraryId,
					//       regionCode,
					//       location: history.location,
					//       target: COSTING_IN_PROGRESS,
					//       parentPage:
					//         regionCode === 'mle' ||
					//         !(response.data.flow || '').includes(DOMESTIC_FLOW_KEY) ||
					//         !isSingleCityDestination(regionCode)
					//           ? INCLUSIONS_VIEW
					//           : ITINERARY_VIEW
					//     })
					//   );
					// }
				}

				res('Promised resolved from fetch')
			},
			onFailure: () => {
				rej('Failed')
			},
		})
	})
}
